import { Box, Container, Flex, Heading } from '@chakra-ui/react';

import { CheckoutHeaderProps } from './checkout-header.props';

export const CheckoutHeader = ({ heading, ...rest }: CheckoutHeaderProps) => {
    return (
        <Box as={'header'} {...rest}>
            <Container maxW={'oldContainerWidth'}>
                <Flex alignItems={'center'} justifyContent={'center'}>
                    <Heading
                        as={'h1'}
                        fontSize={{
                            base: '2xl',
                            md: '4xl',
                        }}
                        textAlign={{
                            base: 'left',
                            md: 'center',
                        }}
                        fontWeight={'normal'}
                    >
                        {heading}
                    </Heading>
                </Flex>
            </Container>
        </Box>
    );
};
